export default __webpack_public_path__ + "static/media/Armguards of the Wicked.c92fbb88.jpg";